import { SelectionChangedEvent } from "ag-grid-community";
import { ExchangeRateRefDateMappingEntity } from "domain/entity/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingEntity";
import { INITIAL_EXCHANGE_RATE_REF_DATE_MAPPING_COL_DEF } from "presentation/constant/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingColumnDefinition";
import { ExchangeRateRefDateMappingConstant } from "presentation/constant/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingConstant";
import { useExchangeRateRefDateMappingVM } from "presentation/hook/ExchangeRateRefDateMapping/useExchangeRateRefDateMappingVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useExchangeRateRefDateMappingTracked } from "presentation/store/ExchangeRateRefDateMapping/ExchangeRateRefDateMappingProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef } from "react";
const ExchangeRateRefDateMappingTablePanel: React.FC = () => {
    const [exchangeState] = useExchangeRateRefDateMappingTracked();
    const exchangeVM = useExchangeRateRefDateMappingVM();
    const gridRef: any = useRef(null);
    const { tableData } = exchangeState;
    const [anaInfoState] = useANAInfoTracked();
    const { allowCreate } = anaInfoState;

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        exchangeVM.updateSelectedRows(selectedRows);
    }, [exchangeVM])
    const handleAddClick = useCallback(() => {
        exchangeVM.onAdd();
    }, [exchangeVM])
    const handleRowDoubleClick = useCallback((entity: ExchangeRateRefDateMappingEntity) => {
        exchangeVM.onEdit(entity);
    }, [exchangeVM])
    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='exchange-rate-ref-date-table'
                headerLabel={ExchangeRateRefDateMappingConstant.TITLE}
                isNewColumnSetting={true}
                columns={INITIAL_EXCHANGE_RATE_REF_DATE_MAPPING_COL_DEF}
                data={tableData ?? []}
                showPaginator={false}
                editable={false}
                showAddIcon={allowCreate}
                onAddClick={handleAddClick}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                onRowDoubleClick={(e: any, entity: ExchangeRateRefDateMappingEntity) => handleRowDoubleClick(entity)}
                gridHeight="customHeight"
                customHeight="calc(100vh - 75px)"
                ref={gridRef}
            />
        );
    }, [allowCreate, tableData, handleAddClick, handleSelectionChange, handleRowDoubleClick])
    return <><TableWrapper>
        {memoTable}
    </TableWrapper>
    </>;
}
export default memo(ExchangeRateRefDateMappingTablePanel); 
